<template>
  <div>
    <BaseHeader></BaseHeader>
    <div class="content">
      <div class="content-top">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item>会议通知</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="content-page">
        <div class="notice-title">会议通知</div>
        <div class="divider"></div>
        <div class="table">
          <div style="border-bottom: 1px solid #d7d8db" v-for="item in tableData.Models" v-bind:key="item.Id">
            <div style="width: 530px; line-height: 48px" class="cursor" @click="detail(item)">
              {{ item.Tilte }}
            </div>
            <div style="float: right; margin-top: -35px">
              {{ item.PublishTime }}
            </div>
          </div>
          <div style="text-align: center; padding-top: 20px">
            <el-pagination background v-model:currentPage="data.PageIndex" layout="prev, pager, next"
              :total="tableData.TotalCount" @size-change="handleSizeChange" @current-change="handleCurrentChange">
            </el-pagination>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { reactive, ref } from "vue";
import router from "../router/index";
import { _local } from "../utils/storage";
import { GetNoticePageList } from "../http/notice";
import { ElMessage } from "element-plus";
import { LoginOut } from "../http/login";
import BaseHeader from "../views/base/BaseHeader.vue";
export default {
  name: "Notice",
  components: {
    BaseHeader,
  },
  setup() {
    const close = () => {
      LoginOut().then(() => {
        _local.remove("token");
        _local.remove("user");
        ElMessage({
          message: "退出成功",
          type: "success",
        });
        router.push("/login");
      });
    };
    let isShowLogin = ref(true);
    const isLogin = () => {
      if (_local.get("token")) {
        isShowLogin.value = false;
      } else {
        isShowLogin.value = true;
      }
    };
    let tableData = reactive({
      Models: [],
      TotalCount: 0,
    });
    let data = reactive({
      title: "",
      PageIndex: 1,
      PageSize: 10,
      IsAsc: false,
      SortFields: ["CreateTime"],
    });
    isLogin();
    const getPagedNoticeList = async () => {
      await GetNoticePageList(data)
        .then((res) => {
          if (res.IsSuccess) {
            tableData.Models = res.Models;
            tableData.TotalCount = res.TotalCount;
            tableData.Models.forEach((m) => {
              m.PublishTime =
                new Date(m.PublishTime).getFullYear() +
                "-" +
                (new Date(m.PublishTime).getMonth() + 1) +
                "-" +
                new Date(m.PublishTime).getDate();
            });
          } else {
            ElMessage.error(res.ErrorMessage);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    };
    getPagedNoticeList();
    const user = _local.get("user");
    const home = () => {
      router.push("/");
    };
    const click = (res) => {
      console.log(res);
    };
    const handleSizeChange = () => {
      getPagedNoticeList();
    };
    const handleCurrentChange = () => {
      getPagedNoticeList();
    };
    const detail = (item) => {
      router.push({
        path: "/noticeDetail",
        query: {
          id: item.Id,
        },
      });
    };
    return {
      isShowLogin,
      home,
      close,
      click,
      user,
      data,
      handleSizeChange,
      handleCurrentChange,
      tableData,
      detail,
    };
  },
};
</script>

<style lang="less" scoped>
.header {
  height: 88px;
}

.logo {
  width: 265.9px;
  height: 48px;
  margin: 0 417.1px 0 0;
  padding: 0 34.2px 0 154.7px;
  background-color: var(--h-0-s-0-l-100);
  margin-top: 19px;
}

.menu {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 10;
  width: 100%;
  height: 88px;
  -webkit-backdrop-filter: blur(32px);
  backdrop-filter: blur(32px);
  background-color: var(--h-0-s-0-l-100);
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.12);
}

.item-text {
  width: 100px;
  height: 30px;
  float: right;
  line-height: 40px;
  margin-top: -6px;
  font-size: 14px;
  padding-left: 10px;
}

.item-text:hover {
  color: #409eff;
}

.home-menu {
  height: 88px;
  display: flex;
  align-items: center;
  justify-content: center;

  >div {
    // padding:0 5% 0 5%;
    text-align: center;
    width: 150px;

    a {
      text-decoration: none;
      color: black;
      width: 40px;
    }
  }
}

#btn-login {
  text-align: center;
  width: 122px;
  //margin: 9px 0 7px 58px;
  padding: 7px 17px;
  border: solid 1px white;

  >span {
    width: 28px;
    // height: 18px;
    font-family: MicrosoftYaHei;
    font-size: 14px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    text-align: left;
    color: white;
  }
}

.content {
  // width: 60%;
  width: 672px;
  margin: 0 auto;

  .content-top {
    margin-top: 23px;
  }

  .content-page {
    width: 672px;
    margin: 0 auto;
    max-height: 600px;
    height: 100%;

    .divider {
      width: 100%;
      height: 1px;
      padding: 0.5px 0;
      background-color: #d7d8db;
      margin-top: 10px;
    }

    .notice-title {
      font-size: 18px;
      font-weight: bold;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.5;
      letter-spacing: 0.64px;
      text-align: left;
      color: #4a4a4a;
      margin-top: 20px;
    }
  }
}

.cursor {
  cursor: pointer;
}
</style>